import React from 'react';
import clsx from 'clsx';
import { SongCardContext } from './Context';
import { CoverImage } from './Cover';
import { CardInfo } from './Info';

export function SongCard(
  props: { children: React.ReactNode } & React.ContextType<typeof SongCardContext>,
) {
  return (
    <SongCardContext.Provider value={{ ...props }}>
      <div
        className={clsx(
          'group relative block h-fit max-h-fit w-full transform-gpu overflow-hidden rounded-lg bg-gradient-to-b from-white via-black to-black',
          props.edition && `after:block after:h-20 after:w-full after:content-['""']`,
          props.loading && 'animate-pulse rounded-lg bg-card-skeleton [&_*]:opacity-0',
        )}
      >
        {props.children}
      </div>
      {props.edition && (
        <div className="relative z-below flex w-full flex-col items-center">
          <div className="h-2 w-[calc(100%-16px)] -translate-y-1 rounded-b-md bg-base500" />
        </div>
      )}
    </SongCardContext.Provider>
  );
}

function CardRunning({
  collected,
  price,
}: {
  /**
   * NFTs collected from the collection.
   */
  collected: React.ReactNode;
  /**
   * Price per edition
   */
  price: React.ReactNode;
}) {
  return (
    <div className="flex h-14 flex-col justify-center bg-black p-3">
      <div className="mb-1 flex justify-between">
        <div className="text-base-s text-base100">Collected</div>
        <div className="text-base-s font-semibold text-base100">{collected}</div>
      </div>
      <div className="flex justify-between">
        <div className="text-base-s text-base100">Price</div>
        <div className="text-base-s font-semibold text-base100">{price}</div>
      </div>
    </div>
  );
}

SongCard.Cover = CoverImage;
SongCard.Info = CardInfo;

/**
 * Use this component to display the running information of the collection.
 */
SongCard.Running = CardRunning;
